import { RecommendedScreen } from './recommended/RecommendedScreen';
import { LiveModeScreen } from '../ui/LiveModeScreen';
import { ConsensusScreen } from './consensus/ConsensusScreen';
import { BroadcastScreen } from './broadcast/BroadcastScreen';
import { HudScreen } from './hud/HudScreen';
import { BoardScreen } from './board/BoardScreen';

/**
 * Live Mode visual variants. Every Screen takes the same prop contract
 * ({ deploymentName, svgUrl, seedAlerts, seedRecs, isLoading, isError,
 * onSelectRec, onSelectAlert, onQuickAct }) and shares data + IA via
 * useLiveModeModel — they differ only in visual language. `key` is the route
 * segment / sub-nav key.
 *
 * `recommended` is the synthesized default (the `/live` route); the rest remain
 * reachable for comparison.
 */
export const LIVE_VARIANTS = {
  recommended: { key: 'live',      label: 'Recommended', Screen: RecommendedScreen },
  terminal:    { key: 'terminal',  label: 'Terminal',    Screen: LiveModeScreen },
  consensus:   { key: 'consensus', label: 'Consensus',   Screen: ConsensusScreen },
  broadcast:   { key: 'broadcast', label: 'News',        Screen: BroadcastScreen },
  hud:         { key: 'command',   label: 'HUD',         Screen: HudScreen },
  board:       { key: 'board',     label: 'Board',       Screen: BoardScreen },
};

export const DEFAULT_VARIANT = 'recommended';
